import { render, staticRenderFns } from "./ReporteVacunas.vue?vue&type=template&id=57f87724"
import script from "./ReporteVacunas.vue?vue&type=script&lang=js"
export * from "./ReporteVacunas.vue?vue&type=script&lang=js"
import style0 from "./ReporteVacunas.vue?vue&type=style&index=0&id=57f87724&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports